<template>
  <div class="search-wrap">
    <div class="search">
      <div class="con">
        <img
          src="../assets/images/search2.png"
          alt=""
          v-if="themeStyleVs == 1"
        />
        <img src="../assets/images/black/search2.png" alt="" v-else />
        <input
          type="text"
          placeholder="请输入股票"
          v-model.trim="searchStockName"
          @input="getStock"
          @keydown.enter="clearSearch"
        />
        <img
          src="../assets/images/close-icon.png"
          alt=""
          @click="clearSearch"
          v-if="themeStyleVs == 1"
        />
        <img
          src="../assets/images/black/close-icon.png"
          alt=""
          @click="clearSearch"
          v-else
        />
      </div>
    </div>
    <ul class="stockList" v-show="isStock">
      <li
        v-for="(item, index) in stockList"
        :key="item.id"
        @click="selectStock(index)"
      >
        {{ item.Id }}
        <em>{{ item.Name }}</em>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        searchStockName: "",
        stockCode: "",
        isStock: false,
        stockList: "", // 股票列表
        themeStyleVs: "",
      };
    },
    mounted() {
      this.themeStyleVs = this.$route.query.themeStyleVs;
    },
    methods: {
      // 获取股票
      getStock() {
        if (this.searchStockName == "") {
          this.stockCode = "";
        }
        this.$http({
          method: "get",
          url:
            window.config.JPB_server +
            "/stock/query?category=沪A,深A,京A&q=" +
            this.searchStockName,
        }).then((res) => {
          if (res.data.ErrCode == 0) {
            this.stockList = res.data.Data.Docs;
            if (this.stockList.length > 0) {
              this.isStock = true;
            }
          }
        });
      },
      // 选择股票
      selectStock(i) {
        this.searchStockName = this.stockList[i].Name;
        this.stockCode = this.stockList[i].Symbol;
        this.isStock = false;
        this.goTp(this.stockCode);
      },
      goTp(code) {
        var url =
          window.config.qytp_link +
          `/yjtp/yzty.html?code=${code}&DZHSPECIAL=285`;
        console.log(url);
        this.toUrl(url);
        this.searchStockName = "";
      },
      // 清除搜索股票
      clearSearch() {
        this.searchStockName = "";
        this.stockList = [];
        this.isStock = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .search-wrap {
    padding-top: 0.4rem;
  }
  .search {
    position: fixed;
    left: 0.08rem;
    right: 0.08rem;
    top: 0rem;
    padding-top: 0.08rem;
    z-index: 2;
    background: #fff;
    .con {
      border-radius: 4px;
      background: #f5f6f8;
      height: 0.32rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.12rem;
    }
    input {
      background: #f6f6f6;
      height: 0.17rem;
      flex: 1;
      color: #222;
      font-size: 0.12rem;
      margin-left: 0.08rem;
      &::placeholder {
        font-size: 0.12rem;
        color: #999;
      }
    }
    img {
      width: 0.13rem;
      flex: none;
    }
  }
  .stockList {
    position: absolute;
    left: 0;
    right: 0;
    top: 0.4rem;
    background: #fff;
    padding: 0 0.16rem;
    li {
      height: 0.48rem;
      line-height: 0.48rem;
      position: relative;
      padding-left: 0.06rem;
      font-size: 0.14rem;
      color: #222;
      &:before {
        @include border(bottom, #e5e5e5);
      }
      em {
        margin-left: 0.06rem;
      }
    }
  }
  .blackTheme {
    .search {
      background: #171922;
      .con {
        background: #252732;
      }
      input {
        background: #252732;
        color: #e4e9fe;
        &::placeholder {
          color: #6b7687;
        }
      }
    }
    .stockList {
      background: #171922;
      li {
        color: #e4e9fe;
        &:before {
          @include border(bottom, #0c0f13);
        }
      }
    }
  }
</style>
